export default "__VITE_ASSET__oR4Xedh7__"